<template>
  <div>
    <n-bread
        v-bind:content="{bread_list, bread_active}"
    ></n-bread>
    <div class="card   abtg__default-card abtg__default-card-border">

      <div class="card-body ">
        <h3>Le caratteristiche del servizio</h3>
        <p>
       Il wallet digitale ti permette di acquistare i servizi aggiuntivi offerti da Real Estate Pro. Puoi ricaricare il tuo wallet con Paypal o carta di credito.
          La ricarica verrà convertita in <strong>crediti</strong> che verranno scalati tutte le volte che utilizzerai uno dei servizi aggiuntivi.
        </p>

        <p style="font-size:20px; padding:20px; background-color: #efefef;">

        Saldo Wallet: <strong><span v-if="walletTotal">{{ walletTotal.total}}</span><span v-else>0</span></strong> crediti.

          <a :href="'https://wallet.abtgtool.com/wallet/' + user"
             class="text-center mt-2 btn btn-success abtg__btn-third shadow-none abtg-button-big"
             onclick="window.open(this.href,'targetWindow',
                                   `toolbar=no,
                                    location=no,
                                    status=no,
                                    menubar=no,
                                    scrollbars=yes,
                                    resizable=yes,
                                    width=600,
                                    height=500`);
 return false;">ACCEDI AL WALLET</a>
        </p>

        <table

            class="
                  mdl-data-table
                  ml-table-striped ml-table-bordered
                  mdl-js-data-table
                  is-upgraded
                  abtg__auction_table_td
                "
        >
          <thead>
          <tr>
            <th class="mdl-data-table__cell--non-numeric text-left">
              Data
            </th>

            <th class="mdl-data-table__cell--non-numeric text-left">
              Operazione
            </th>

            <th class="mdl-data-table__cell--non-numeric text-left">
              Importo
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(mov, index) in movements">
            <td style="white-space: normal">
              {{mov.created_at.slice(0,15).replace('T', ' ')}}
            </td>

            <td style="white-space: normal">
              {{mov.operation_type}}
            </td>

            <td style="white-space: normal">
              {{mov.amount}}
            </td>
          </tr>
          </tbody>

        </table>



      </div>
    </div>
  </div>
</template>

<script>
import NBread from '@/partials/bread';
import {mapActions, mapState, mapMutations} from 'vuex';

export default {
  components: {
    NBread
  },
  computed: {
    ...mapState('n_wallet', ['walletTotal', 'movements', 'user', 'bread_list', 'bread_active']),
  },

  created() {
    this.SET_DATA({name: 'bread_active', data: {label: 'Wallet Digitale'}});
    this.SET_DATA({name: 'total', data: {label: 'Wallet Digitale'}});
    this.myWallet();
    this.walletMovements();
  },
  methods: {
    ...mapActions('n_wallet', ['myWallet','walletMovements']),
    ...mapMutations('n_wallet', ['SET_DATA']),
  }
}
</script>
